import React from "react";
import "./ManufacturingDataAndProcessManagement.css";
import ManufacturingDataOverview from "./ManufacturingDataOverview";
import BannerImage from "../../../assets/other_image/Manufacturing_project_management.jpg";
import Letsgetintouch from "../BusinessProcessAndChangeManagement/Letsgetintouch";
import { NavLink } from "react-router-dom";
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import { Helmet } from "react-helmet-async";

const ManufacturingDataAndProcessManagement = () => {
  return (
    <>
      <Helmet>
        <title>Teamcenter Manufacturing Data &amp; Process Management | NexTech PLM</title>
        <meta name="description" content="Optimize manufacturing workflows with Teamcenter Manufacturing Data & Process Management. NexTech PLM helps companies improve process planning, MBOM, BOP, and factory simulation for smarter production." />
        <meta name="keywords" content="Teamcenter manufacturing data management, MBOM BOP Pune, manufacturing process planning India, Teamcenter factory simulation, PLM manufacturing services" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <link rel="canonical" href="https://nextechplm.com/teamcenter-manufacturing-data-process-management" />
        <meta property="og:site_name" content="NexTech PLM Solutions" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Teamcenter Manufacturing Data & Process Management | NexTech PLM" />
        <meta property="og:description" content="Optimize manufacturing workflows with Teamcenter Manufacturing Data & Process Management. NexTech PLM improves process planning, MBOM, BOP, and factory simulation." />
        <meta property="og:url" content="https://nextechplm.com/teamcenter-manufacturing-data-process-management" />
        <meta property="og:image" content="https://nextechplm.com/logo192.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Teamcenter Manufacturing Data & Process Management | NexTech PLM" />
        <meta name="twitter:description" content="Optimize manufacturing workflows with Teamcenter Manufacturing Data & Process Management. NexTech PLM improves process planning, MBOM, BOP, and factory simulation." />
        <meta name="twitter:image" content="https://nextechplm.com/logo192.png" />
      </Helmet>

      <section className="ManufacturingData-management">
        <Banner
          image={BannerImage} // Pass the image for this page
          heading="Teamcenter Manufacturing Data and process management" // Pass the heading text for this page
        />

        <div>
          <FloatingContactUs />
        </div>

        <ManufacturingDataOverview />

        <section style={{ background: "#f5f7fa" }}>
          <div className="benefits container">
            <h4 className="ManufacturingData-page-heading">Unlock the Power :</h4>
            <h5 className="ManufacturingData-subheading">
              Discover the Transformative Benefits of Teamcenter Manufacturing Data and
              process management with NexTech!
            </h5>
            <p className="plmimplementationparagraph">
              Our unique methodology to implement Teamcenter manufacturing helps customer to
              effectively utilize Siemens PLM Manufacturing Engineering solutions to become a High
              Tech manufacturer to achieve below goal.
            </p>
            <ul className="custom-bullets">
              <li>Increased quality and accuracy of data </li>
              <li>Reduced lead time and waste </li>
              <li>Maximize use of resources</li>
            </ul>
          </div>
        </section>

        <section>
          <div className="solutions container">
            <div className="solutions-content">
              <div className="row">
                <div className="col-md-6 col-12">
                  <h4 className="ManufacturingData-page-heading">Teamcenter Solutions</h4>

                  <ul className="custom-bullets">
                    <li>Teamcenter Manufacturing </li>
                    <li>Teamcenter Classification </li>
                    <li>Easy-PLAN </li>
                    <li>Manufacturing change management </li>
                    <li>BOP Management </li>
                    <li>Part Planning </li>
                    <li>EBOM - MBOM Management </li>
                  </ul>
                </div>

                <div className="col-md-6 col-12">
                  <div className="quick-links">
                    <h4>Quick Links</h4>
                    <ul>
                      <li>
                        <NavLink to="/teamcenter-plm-erp-data-process-management">
                          PLM - ERP (SAP, Oracle, HANA) Data and Process Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-bom-management">
                          Product BOM and Variability Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-community-collaboration">
                          Teamcenter Community Collaboration
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-cybersecurity">
                          Teamcenter Cyber security
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-cloud-implementation">
                          Teamcenter Implementation on Cloud
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-implementation">
                          Teamcenter Implementation
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-cae-integration">
                          Teamcenter Integration for CAE
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-cam-integration">
                          Teamcenter Integration for CAM
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="best-practices container">
            <h4 className="ManufacturingData-page-heading">Best Practices</h4>
            <p className="plmimplementationparagraph">
              We help customer to develop a solutions using Teamcenter Manufacturing along with
              integrated tools for business requirement like process planning, part planning,
              process simulation, resource management, factory design & simulation which enable
              in true sense virtual manufacturing engineering.
            </p>
          </div>
        </section>

        <section style={{ background: "#f5f7fa" }}>
          <div className="why-nextech container">
            <h4 className="ManufacturingData-page-heading ">Why NexTech?</h4>
            <h5 className="ManufacturingData-subheading">
              For Manufacturing Data and Process Management
            </h5>
            <ul className="custom-bullets">
              <li>
                Comprehensive integration of Teamcenter Manufacturing with leading solutions like
                Tecnomatix, Process Simulate, and MES for seamless process optimization.
              </li>
              <li>
                Expertise in developing tailored solutions using Teamcenter Manufacturing and
                integrated tools to address specific business requirements in manufacturing
                engineering.
              </li>
              <li>
                Specialized methodologies to enhance data quality and accuracy, reduce lead time,
                and minimize waste in manufacturing processes.
              </li>
              <li>
                Proficiency in establishing standardized processes for effective handling of
                engineering and manufacturing changes, ensuring synchronized release of all
                impacted data.
              </li>
              <li>
                Robust capabilities in classification and resource management, including the
                development of resource libraries and standardized process templates for
                streamlined operations.
              </li>
            </ul>
          </div>
        </section>

        <Letsgetintouch />
      </section>
    </>
  );
};

export default ManufacturingDataAndProcessManagement;
